import React from "react";
import { useSelector } from "react-redux";
const ICON_LOADER_LIGHT = require("../assets/loader_light.svg");
const ICON_LOADER_DARK = require("../assets/loader_dark.svg");

const DefaultSpinner = () => {
  const { appContrast } = useSelector((state) => state.app);

  const ICON = appContrast ? ICON_LOADER_LIGHT : ICON_LOADER_DARK;

  return (
    <div className="container d-flex align-items-center justify-content-center spinner-container">
      <img alt="Ładowanie strony..." src={ICON} className="spinner-icon" /> 
    </div>
  );
};

export default DefaultSpinner;



// WEBPACK FOOTER //
// ./src/components/Spinner.js